import {Api} from "./api"

export default class MessageApi extends Api {
    constructor() {
        super("/message");
    }

    async MessageNotice() {
        return await this.call("/notice_message")
    }

    async MessageReceived(alertID: number) {
        return await this.call("/received_message", {alertID})
    }

    async MessageSearchForList(projectID: number, serviceID: number, startDate: string, endDate: string, alertID: number, level: number, key: string, pageSize: number, pageIndex: number) {
        return await this.call("/search_message_for_list", {
            projectID,
            serviceID,
            startDate,
            endDate,
            alertID,
            level,
            key,
            pageSize,
            pageIndex
        })
    }

    async MessageSearchForRecent(num: number) {
        return await this.call("/search_message_for_recent", {num})
    }


    async MessageSearchForGraph(projectID: number, serviceID: number, startDate: string, endDate: string, alertID: number, level: number, key: string) {
        return await this.call("/search_message_for_graph", {
            projectID,
            serviceID,
            startDate,
            endDate,
            alertID,
            level,
            key
        })
    }

    async ProjectCatalog() {
        return await this.call("/projectCatalog_message")
    }

    async ServiceCatalog(projectID: number) {
        return await this.call("/serviceCatalog_message", {projectID})
    }

    async AlertCatalog(projectID: number, serviceID: number) {
        return await this.call("/alertCatalog_message", {projectID, serviceID})
    }

    async MessageCount(startDate: string, endDate: string) {
        return await this.call("/count_message", {startDate, endDate})
    }

}